/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_LatestInputs */

const en_ui_rail_latest = /** @type {(inputs: Ui_Rail_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`latest`)
};

const de_ui_rail_latest = /** @type {(inputs: Ui_Rail_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktuell`)
};

/**
* | output |
* | --- |
* | "latest" |
*
* @param {Ui_Rail_LatestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_latest = /** @type {((inputs?: Ui_Rail_LatestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_LatestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_latest(inputs)
	return de_ui_rail_latest(inputs)
});